import { PlusOutlined } from '@ant-design/icons'
import { FloatButton } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { MilestoneControls } from './components/milestone-controls/milestone-controls'
import { MilestoneTable } from './components/milestone-table/milestone-table'
import { RouteEnum } from '../../../constants/routes.enum'
import { useGetUserWorkflows } from '../../../entities/workflow/hooks/workflow.hooks'
import { MilestoneItem } from '../../../entities/workflow/types/workflow.types'
import { PageHeader } from '../../shared/components/page-header'

export const MilestonePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data: milestones } = useGetUserWorkflows()
  const [milestonesState, setMilestonesState] = useState<MilestoneItem[]>([])

  useEffect(() => {
    setMilestonesState(milestones ?? [])
  }, [milestones])

  const handleAddMilestone = () => {
    navigate(`${RouteEnum.ADD}`)
  }

  const handleSearchMilestone = (search: string) => {
    if (search) {
      const filteredMilestones = milestones?.filter((milestone) => milestone.name.toLowerCase().includes(search.toLowerCase()))
      setMilestonesState(filteredMilestones ?? [])
    } else {
      setMilestonesState(milestones ?? [])
    }
  }

  return (
    <>
      <div>
        <PageHeader
          description={t('milestone.description')}
          header={t('milestone.header')}
        />
        <MilestoneControls onSearch={handleSearchMilestone} />
        <div className="mt-3">
          <MilestoneTable milestones={milestonesState} />
        </div>
      </div>
      <FloatButton
        icon={<PlusOutlined />}
        onClick={handleAddMilestone}
        type="primary"
      />
    </>
  )
}
